import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhom() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8" data-id="element-82">
      <div className="max-w-5xl mx-auto" data-id="element-83">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-84">
          {/* Who this is for */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-3xl p-8 shadow-soft border border-green-100" data-id="element-85">
            <h3 className="text-2xl font-bold mb-6 text-brand-dark flex items-center gap-2" data-id="element-86">
              <span className="bg-green-100 text-green-600 p-1.5 rounded-lg" data-id="element-87">
                <CheckCircle2 size={24} data-id="element-88" />
              </span>
              Este manual ES para:
            </h3>
            <ul className="space-y-4" data-id="element-89">
              {['Padres que quieren ayudar con las tareas sin sentirse obsoletos.', 'Profesores que desean recuperar sus fines de semana automatizando su planificación.', 'Educadores que buscan detectar el plagio y fomentar el pensamiento crítico.', "Cualquier adulto 'cero técnico' que quiera entender el futuro hoy mismo."].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-90">
                  <CheckCircle2 className="text-green-500 shrink-0 mt-0.5" size={20} data-id="element-91" />
                  <span className="text-brand-text" data-id="element-92">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is not for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-cream-50 rounded-3xl p-8 border border-cream-200" data-id="element-93">
            <h3 className="text-2xl font-bold mb-6 text-brand-dark flex items-center gap-2" data-id="element-94">
              <span className="bg-red-100 text-red-500 p-1.5 rounded-lg" data-id="element-95">
                <XCircle size={24} data-id="element-96" />
              </span>
              Este manual NO es para:
            </h3>
            <ul className="space-y-4" data-id="element-97">
              {['Ingenieros de sistemas que buscan programación avanzada.', 'Personas que creen que la IA debe hacer todo el trabajo sin supervisión humana.', 'Quienes no tienen interés en participar activamente en la educación de los menores.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-98">
                  <XCircle className="text-red-400 shrink-0 mt-0.5" size={20} data-id="element-99" />
                  <span className="text-brand-text" data-id="element-100">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}